import { MarkElementMask } from './MarkElementMask';
import { dom } from '@Engage.Core';
export class BlurMask extends MarkElementMask {
    constructor(maskingOptions) {
        super(maskingOptions);
        this.blurClass = 'blurry-text';
        if (!this.maskElement)
            return; // selector not found — nothing to blur
        this.blurContent(this.maskElement);
    }
    blurContent(element) {
        this.markExcluded(element);
        const result = this.splitElement(element);
        this.blurNotMarked(result.updatedElement);
    }
    blurNotMarked(parent) {
        const blurElements = this.getNotMarkedElements(parent);
        blurElements.forEach((element) => {
            if (!this.isElementHasExcludes(element)) {
                this.blurElementOwnText(element);
            }
        });
    }
    blurElementOwnText(element) {
        const ownElementText = this.textContent(element);
        if (ownElementText.length > 0) {
            this.setOwnText(element);
        }
    }
    encryptContent(htmlNode) {
        if (dom.children(htmlNode).length === 0) {
            let nodeText = dom.text(htmlNode);
            dom.addClass(htmlNode, this.blurClass);
            dom.text(htmlNode, this.encryptText(nodeText));
        }
        else {
            dom.children(htmlNode).forEach((childHtmlNode) => {
                if (!this.isElementHasExcludes(htmlNode)) {
                    this.blurElementOwnText(childHtmlNode);
                    this.encryptContent(childHtmlNode);
                }
            });
        }
    }
    ;
    setOwnText(element) {
        const childNodes = element.childNodes;
        Array.from(childNodes).forEach((child) => {
            if (child.nodeType === 3 && child.textContent.trim().length > 0) {
                const textContent = this.encryptText(child.textContent);
                child.nodeValue = textContent;
                dom.addClass(child.parentNode, this.blurClass);
            }
        });
    }
    encryptText(text) {
        if (text) {
            for (let i = 0; i < text.length; i++) {
                text = this.replaceAt(text, i, this.getNextLetter(text[i]));
            }
        }
        return text;
    }
    replaceAt(str, index, replacement) {
        return str.substring(0, index) + replacement + str.substring(index + 1);
    }
    getNextLetter(char) {
        return char.replace(/([a-zA-Z])[^a-zA-Z]*$/, function (a) {
            let c = a.charCodeAt(0);
            switch (c) {
                case 90: return "A";
                case 122: return "a";
                default: return String.fromCharCode(++c);
            }
        });
    }
    ;
}
